var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-shrink-0 align-middle content-center leading-snug",class:{ 'box-title-l-1': _vm.lines == 1, 'box-title-l-2': _vm.lines == 2 }},[_c('h1',{staticClass:"text-chplus-title-color-l",class:{
      'text-color-white': _vm.color == 'white',
      'text-chplus-blue-gradient': _vm.color == 'blue'
    }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }